import { StoreData } from 'app/types-shared';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import { getChildEntities } from 'app/infrastructure/store/query';
import get from 'lodash/get';

export const getChildEntitiesFromPath = (
  appState: any,
  uiEngineProps: any,
  levelsUp: number,
  tableName: string
) => {
  const hostProps = uiEngineProps.hostProps();
  const caseState = get(appState, hostProps.statePath);
  const caseData: StoreData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);

  const path = !!levelsUp
    ? entityContext.path.slice(0, -levelsUp)
    : entityContext.path;

  return getChildEntities(caseData, path, tableName);
};
